import { UIType } from './uiTypes'
import { ReduxAction } from '../../reducers/reducerType'
import { SettingsTabs } from '../../../components/SettingsModal/types'
import { SidePanelTypes, mediaType as MediaType } from '@bt-react/constants'
import { setMediaType } from '../room/room'
import get from 'lodash/get'
import storage from '../../../lib/storage'
import docUpdateAndLog from '../../../lib/docUpdateAndLog'

/* MODALS */
export const openGigStartConfirmationModal = (): ReduxAction => ({ type: UIType.OPEN_GIG_START_CONFIRMATION_MODAL })
export const closeGigStartConfirmationModal = (): ReduxAction => ({ type: UIType.CLOSE_GIG_START_CONFIRMATION_MODAL })
export const openGigEndConfirmationModal = (): ReduxAction => ({ type: UIType.OPEN_GIG_END_CONFIRMATION_MODAL })
export const closeGigEndConfirmationModal = (): ReduxAction => ({ type: UIType.CLOSE_GIG_END_CONFIRMATION_MODAL })

export const showDeadMansHandle = (): ReduxAction => ({ type: UIType.SHOW_DEAD_MANS_HANDLE })
export const showStreamModal = (): ReduxAction => ({ type: UIType.SHOW_STREAM_MODAL })
export const hideStreamModal = (): ReduxAction => ({ type: UIType.HIDE_STREAM_MODAL })

export const toggleModal = (): ReduxAction => ({ type: UIType.TOGGLE_MODAL})

export const showSettingsModal = (tab?: SettingsTabs) => ({ type: UIType.SHOW_SETTINGS_MODAL, payload: tab })
export const hideSettingsModal = () => ({ type: UIType.HIDE_SETTINGS_MODAL })

export const showRescheduleModal = () => ({ type: UIType.SHOW_RESCHEDULED_MODAL })
export const hideRescheduleModal = () => ({ type: UIType.HIDE_RESCHEDULED_MODAL })

export const showPlayInModal = () => ({ type: UIType.SHOW_PLAY_IN_MODAL })
export const hidePlayInUploadModal = () => ({ type: UIType.HIDE_PLAY_IN_MODAL })

export const showSlidesUploadModal = () => ({ type: UIType.SHOW_SLIDES_UPLOAD_MODAL })
export const hideSlidesUploadModal = () => ({ type: UIType.HIDE_SLIDES_UPLOAD_MODAL })
export const setRescheduledViewed = () => (dispatch, getState) => {

  const { channelId, webcastId } = getState().config
  const { bookingDoc } = getState().docs
  const { dateUpdated } = bookingDoc

  storage.setItem('talks-rescheduled', {
    gig: `${channelId}-${webcastId}`,
    dateUpdated
  })

}

/* MEDIA DRAWERS */
export const toggleMediaDrawer = () => ({ type: UIType.TOGGLE_MEDIA_DRAWER })
export const openPlayInMediaDrawer = () => ({ type: UIType.OPEN_PLAY_IN_MEDIA_DRAWER })
export const closePlayInMediaDrawer = () => ({ type: UIType.CLOSE_PLAY_IN_MEDIA_DRAWER })
export const openSlidesMediaDrawer = () => ({ type: UIType.OPEN_SLIDES_MEDIA_DRAWER })
export const closeSlidesMediaDrawer = () => ({ type: UIType.CLOSE_SLIDES_MEDIA_DRAWER })
export const openSpotlightMediaDrawer = () => ({ type: UIType.OPEN_SPOTLIGHT_MEDIA_DRAWER })
export const closeSpotlightMediaDrawer = () => ({ type: UIType.CLOSE_SPOTLIGHT_MEDIA_DRAWER })

/* SIDE PANEL */
export const openSidePanel = () => ({ type: UIType.OPEN_SIDE_PANEL })
export const closeSidePanel = () => (dispatch, getState) => {

  const { ui: { menuItemSelected } } = getState()

  dispatch({ type: UIType.CLOSE_SIDE_PANEL, payload: menuItemSelected })

}
export const setSelectedMenuItem = (item: SidePanelTypes) => ({ type: UIType.SET_SELECTED_MENU_ITEM, payload: item })
export const setFeatureFlag = (feature: string, value: string) => ({ type: UIType.SET_FEATURE_FLAG, payload: { feature, value } })

export const stopScreenShare = (isLayoutsActive: boolean, trackSid: string) => async (dispatch, getState) => {

  if (trackSid) {

    const screenshareTrack = get(getState().room, 'room.localParticipant.videoTracks', new Map()).get(trackSid)
    if (screenshareTrack) {

      try {

        screenshareTrack.track.stop()
        screenshareTrack.track.detach()

      }
      catch (e) {

        console.log(e)

      }

    }

  }

  if (!isLayoutsActive) {
    await docUpdateAndLog(getState().docs.uiDoc, { screenShareFocus: null, mediaType: MediaType.WEBCAM }, 'uiDoc')
    dispatch(setMediaType(MediaType.WEBCAM))
  }

}

export default {
  openGigStartConfirmationModal,
  closeGigStartConfirmationModal,
  openGigEndConfirmationModal,
  closeGigEndConfirmationModal,
  showDeadMansHandle,
  showStreamModal,
  hideStreamModal,
  toggleModal,
  showSettingsModal,
  hideSettingsModal,
  showRescheduleModal,
  hideRescheduleModal,
  showPlayInModal,
  hidePlayInUploadModal,
  showSlidesUploadModal,
  hideSlidesUploadModal,
  toggleMediaDrawer,
  openPlayInMediaDrawer,
  closePlayInMediaDrawer,
  openSlidesMediaDrawer,
  closeSlidesMediaDrawer,
  openSpotlightMediaDrawer,
  closeSpotlightMediaDrawer,
  openSidePanel,
  closeSidePanel,
  setSelectedMenuItem,
  setFeatureFlag,
  setRescheduledViewed
}
